<template>
<div>
   <Breadcrumb> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ name:'impressum'}">Impressum</router-link></span>
     </Breadcrumb>
    <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>Impressum</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                      <div class=" entry-content">
                                        <div class="row u-margin-b-30">
                                        <div class="col-sm-4">
                                            <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa fa-user"></i> Sead Numanović</h5>
                                             <p class="card-text">Glavni i odgovorni urednik</p>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa fa-user"></i> Almasa Hadžić</h5>
                                                <p class="card-text">Urednik</p>
                                            </div>
                                            </div>
                                        </div>
                                       <div class="col-sm-4">
                                            <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa fa-user"></i> Slađan Tomić</h5>
                                                 <p class="card-text">Saradnik</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>     
 </template>

<script>
    import { AboutService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'

    export default {
        name: "Impressum",
        components: { Breadcrumb },
        metaInfo: {
            title: 'Impressum',        
        },
        data() {
            return {}
        },
        mounted() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
     .widget--border-box.social-grid .media-lists li {
        flex: 0 0 25.000%;
        -webkit-flex: 0 0 25.000%;
        -ms-flex: 0 0 25.000%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Impressum.vue